import { IconButtonProps } from '@chakra-ui/react';
import { HiX } from 'react-icons/hi';

import { useUIStore } from '$stores/ui';

import { SidebarButton } from './sidebar-button';

export function CloseSidebarButton(props: Omit<IconButtonProps, 'aria-label'>) {
  const { closeSidebar } = useUIStore();

  function handleCloseSidebar() {
    closeSidebar();
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  }

  return (
    <SidebarButton
      {...props}
      aria-label="Fechar menu"
      icon={HiX}
      onClick={handleCloseSidebar}
    />
  );
}
